export const DEPOSIT_CARD_B2B_LIMIT = 10000_00;
export const DEPOSIT_CARD_LIMIT_ER = 10000_00;
export const DEPOSIT_APPLE_PAY_B2B_LIMIT = 10000_00;
export const DEPOSIT_REGULAR_BANK_TRANSFER_LIMIT = 250000_00;
export const DEPOSIT_SEPA_DD_LIMIT = 250000_00;
export const DEPOSIT_OTHER_METHODS_LIMIT = 250000_00;

export const MUTUAL_FUND_ORDER_LIMIT = 250000_00;
export const FULLY_MANAGED_ORDER_LIMIT = 250000_00;

export const BO_VOLUNTARY_PAYMENT_LIMIT = 50000_00;
